import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Navbar = ({ onReservar }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-[#262626]' : 'bg-transparent'}`
      }
      data-testid="navbar">

      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <div className="flex flex-col cursor-pointer" onClick={() => scrollTo('hero')}>
          <span className="font-heading text-2xl font-bold text-gold tracking-wider">NELI</span>
          <span className="text-[10px] tracking-[0.3em] text-[#a3a3a3] uppercase -mt-1">Restaurante</span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {[
          { label: 'Inicio', id: 'hero' },
          { label: 'Nosotros', id: 'about' },
          { label: 'Servicios', id: 'services' },
          { label: 'Contacto', id: 'contact' }].
          map((item) =>
          <button
            key={item.id}
            onClick={() => scrollTo(item.id)}
            className="text-[#a3a3a3] hover:text-gold transition-colors duration-300 text-sm tracking-widest uppercase font-body">

              {item.label}
            </button>
          )}
        </div>

        {/* CTA Button */}
        <div className="flex items-center gap-4">
          <button
            data-testid="nav-reservar-btn"
            onClick={onReservar}
            className="hidden md:block uppercase hover:bg-gold-dark transition-all duration-300 text-xs font-bold tracking-widest px-6 py-3 !rounded-[20px] text-black bg-gold">

            Reservar Mesa
          </button>
          {/* Mobile menu toggle */}
          <button
            className="md:hidden text-[#ededed] hover:text-gold transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-btn">

            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen &&
      <div className="md:hidden bg-[#0a0a0a] border-t border-[#262626] px-6 py-6 flex flex-col gap-6">
          {[
        { label: 'Inicio', id: 'hero' },
        { label: 'Nosotros', id: 'about' },
        { label: 'Servicios', id: 'services' },
        { label: 'Contacto', id: 'contact' }].
        map((item) =>
        <button
          key={item.id}
          onClick={() => scrollTo(item.id)}
          className="text-[#a3a3a3] hover:text-gold transition-colors text-sm tracking-widest uppercase text-left">

              {item.label}
            </button>
        )}
          <button
          data-testid="mobile-reservar-btn"
          onClick={() => {setMenuOpen(false);onReservar();}}
          className="bg-gold text-black text-sm font-bold tracking-widest uppercase px-6 py-3 rounded-[20px] hover:bg-gold-dark transition-all">

            Reservar Mesa
          </button>
        </div>
      }
    </nav>);

};

export default Navbar;